var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap"},[_c('div',{staticClass:"doing"},[_c('div',{staticClass:"doing-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"doing-content",domProps:{"innerHTML":_vm._s(_vm.content)}})]),_c('bottom',{staticStyle:{"flex":"0 0 2.2rem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }